import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "ip-text" }
const _hoisted_3 = { class: "ip-title" }
const _hoisted_4 = { class: "ip-desc" }
const _hoisted_5 = { class: "ip-actions" }

import { computed, onMounted, ref } from 'vue'
import {
  canInstall, isInstalled, isIosDevice,
  promptInstall, rememberDismissed, wasDismissed,
} from '@/utils/pwa'

// Hodisa tinglovchisi bu yerda EMAS — u `utils/pwa.js` da, Vue mount
// bo'lishidan oldin ulanadi. Sabab: `beforeinstallprompt` sahifa
// yuklanishida bir marta ishga tushadi va ilova `/login` bilan ochiladi,
// ya'ni komponent hali mavjud bo'lmagan paytda. Ilgari aynan shu sababdan
// taklif hech qachon chiqmagan.


export default {
  __name: 'InstallPrompt',
  setup(__props) {

const dismissed = ref(false)
const isIos = ref(false)

onMounted(() => {
  dismissed.value = wasDismissed()
  isIos.value = isIosDevice()
})

const visible = computed(() => {
  if (dismissed.value || isInstalled.value) return false
  // iOS da brauzer taklif bermaydi — ko'rsatma ko'rsatamiz.
  if (isIos.value) return true
  return canInstall.value
})

async function install() {
  await promptInstall()
}

function dismiss() {
  dismissed.value = true
  rememberDismissed()
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_Transition, { name: "ip-fade" }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "install-prompt",
            role: "dialog",
            "aria-label": _ctx.$t('pwa.title')
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: "/icons/icon-192.png",
              alt: "",
              class: "ip-icon"
            }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('pwa.title')), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(isIos.value ? _ctx.$t('pwa.iosHint') : _ctx.$t('pwa.desc')), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (!isIos.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "ip-btn ip-btn--primary",
                    type: "button",
                    onClick: install
                  }, _toDisplayString(_ctx.$t('pwa.install')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "ip-btn",
                type: "button",
                onClick: dismiss
              }, _toDisplayString(_ctx.$t('pwa.later')), 1)
            ])
          ], 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

}